<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{$route.meta.title}}
                        <el-button class="title_btn" type="primary" @click="moveCreate('create')">등록</el-button>
                        <el-button class="title_btn success" @click="moveCreate('category')" type="success">카테고리 관리</el-button>
                    </div>
                    <board-list-component :boardType="`JstFaq`"></board-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BoardListComponent from "@/components/board/BoardListComponent";
    export default {
        name: 'JustFaq',
        mixins: [],
        components: {
            BoardListComponent,
        },
        props: {
        },
        data() {
            return{

            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            moveCreate(type= null) {
                this.$router.replace(this.$route.path);
                this.$router.push(`/jst/service/faq/${type}`)
            }
        },
        watch: {

        },
    }
</script>
